import React, { createContext, useContext, useMemo, useCallback } from 'react';
import { getSessionStorageValue, setSessionStorageValue, STORAGE_KEYS } from '../../Utils/SessionStorage';
import { DEFAULT_OUTLET_TYPE } from '../../Utils/bookingConfig';

const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [selectedOutletID, setSelectedOutletIDState] = React.useState(
    () => getSessionStorageValue(STORAGE_KEYS.SELECTED_OUTLET_ID) || null
  );

  const [selectedOutletContact, setSelectedOutletContactState] = React.useState(
    () => getSessionStorageValue(STORAGE_KEYS.SELECTED_OUTLET_CONTACT) || ''
  );

  const [selectedOutletWhatsapp, setSelectedOutletWhatsappState] = React.useState(
    () => getSessionStorageValue(STORAGE_KEYS.SELECTED_OUTLET_WP) || ''
  );

  const [outletTypeID, setOutletTypeIDState] = React.useState(
    () => getSessionStorageValue(STORAGE_KEYS.OUTLET_TYPE) || DEFAULT_OUTLET_TYPE
  );

  const setSelectedOutletID = useCallback((outletID) => {
    setSelectedOutletIDState(outletID);
    setSessionStorageValue(STORAGE_KEYS.SELECTED_OUTLET_ID, outletID);
  }, []);

  const setSelectedOutletContact = useCallback((contact) => {
    setSelectedOutletContactState(contact);
    setSessionStorageValue(STORAGE_KEYS.SELECTED_OUTLET_CONTACT, contact);
  }, []);

  const setSelectedOutletWhatsapp = useCallback((whatsapp) => {
    setSelectedOutletWhatsappState(whatsapp);
    setSessionStorageValue(STORAGE_KEYS.SELECTED_OUTLET_WP, whatsapp);
  }, []);

  const setOutletTypeID = useCallback((typeID) => {
    setOutletTypeIDState(typeID);
    setSessionStorageValue(STORAGE_KEYS.OUTLET_TYPE, typeID);
  }, []);

  const value = useMemo(
    () => ({
      selectedOutletID,
      setSelectedOutletID,
      selectedOutletContact,
      setSelectedOutletContact,
      selectedOutletWhatsapp,
      setSelectedOutletWhatsapp,
      outletTypeID,
      setOutletTypeID,
    }),
    [
      selectedOutletID,
      setSelectedOutletID,
      selectedOutletContact,
      setSelectedOutletContact,
      selectedOutletWhatsapp,
      setSelectedOutletWhatsapp,
      outletTypeID,
      setOutletTypeID,
    ]
  );

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation must be used within LocationProvider');
  }
  return context;
};

export default LocationContext;
